<ng-container *ngIf="validationMessages[controlName]">
  <ng-container *ngFor="let validation of validationMessages[controlName];">
    <ngx-error-message *ngIf="group.get(controlName).hasError(validation.type) && group.get(controlName).dirty">
      {{ validation.message | translate: group.get(controlName).getError(validation.type) }}
    </ngx-error-message>
  </ng-container>
</ng-container>
